import { render } from "./About.vue?vue&type=template&id=2fd9d1e7&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=2fd9d1e7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fd9d1e7"

export default script